// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__DqK92"};